import gql from 'graphql-tag'

export const pullPricesForAdditionalCreditsQuery = gql`
  {
    pullPricesForAdditionalCredits
  }
`
